<template>
  <v-app>
    <v-main>
      <RouterView />
    </v-main>

    <Toaster position="top-right" rich-colors />

    <DeepReloadPrompt v-if="!isLocalEnv()" />

    <DeepLoader />

    <LandscapeHint v-if="isLandscape" :show="isLandscape" />
  </v-app>
</template>
<script setup lang="ts">
import 'vue-sonner/style.css'
import { Toaster } from 'vue-sonner'
import { useTheme } from 'vuetify'
import { DeepLoader, DeepReloadPrompt } from '@deepcloud/deep-ui-lib'
import { getAppWindowTitle, isLocalEnv } from '@/util/env.ts'
import { useEmbed } from '@/composables/use-embed.ts'
import { useOrientation } from '@/composables/use-orientation.ts'
import LandscapeHint from '@/components/app/LandscapeHint.vue'

const isLandscape = useOrientation()
const { isEmbedded, fitsContent, embedPrimaryColor, reportContentHeight } =
  useEmbed()
const theme = useTheme()

if (isEmbedded.value) {
  if (fitsContent.value) {
    document.documentElement.classList.add('is-embedded-fit')
    reportContentHeight(document.body)
  }

  if (embedPrimaryColor.value) {
    theme.themes.value.deepSign.colors.primary = embedPrimaryColor.value
  }
  theme.change('deepSign')
}

document.title = getAppWindowTitle()
</script>
